import { LowerCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { type ProfileType } from '@rma/common-ui-domain/types';
import { NO_PROPERTY_IMAGE } from '@rma/generic/domain/types';
import { AvatarStackComponent } from '@rma/generic/ui/avatar-stack';
import { TrixelComponent } from '@rma/generic/ui/trixels';
import { StaticImageUrlPipe } from '@rma/generic/util/environment';
import { TimeAgoPipe } from '@rma/generic/util/pipes/date';
import { ImageOptimisePipe } from '@rma/generic/util/pipes/image-optimiser';
import { ProfileSummaryComponent } from '@rma/profiles/public/ui-profile-summary';
import { SearchReview } from '@rma/reviews/public/domain';
import { StarRatingComponent } from '@rma/reviews/public/ui-rating';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
  selector: 'rma-review-tile-list',
  imports: [
    AvatarStackComponent,
    ImageOptimisePipe,
    LazyLoadImageModule,
    LowerCasePipe,
    ProfileSummaryComponent,
    RouterModule,
    StarRatingComponent,
    StaticImageUrlPipe,
    TimeAgoPipe,
    TranslocoModule,
    TrixelComponent,
  ],
  templateUrl: './review-tile-list.component.html',
})
export class ReviewTileListComponent {
  @Input()
  public reviews: SearchReview[] | null = [];

  @Input()
  public profileType: ProfileType | null = null;

  @Input()
  public profileCode: string | null = null;

  @Input()
  public hideImage: boolean | null = false;

  @Input()
  public lazyLoadFirst = true;

  @Input()
  public useHref: boolean | null = false;

  @Input()
  public trixelSourceCategory?: string;

  @Input()
  newTab = false;

  @Output()
  mouseOver = new EventEmitter<string>();

  @Output()
  mouseOut = new EventEmitter<string>();

  public readonly defaultImageUrl = NO_PROPERTY_IMAGE;
}
